module.exports = __webpack_public_path__ + "static/media/forward.49eef314.png";